import { OrbitForgeRuntime } from "../game/runtime/runtime";
import { createArena } from "../rendering/arena";
import { startGameLoop } from "./game-loop";
import { createHud } from "../ui/hud";
import { createUiShell } from "../ui/shell";

export function mountOrbitForge(root: HTMLElement): void {
  const runtime = new OrbitForgeRuntime(window.localStorage, Math.floor(Date.now() / 1000));
  root.replaceChildren(createUiShell(createHud(runtime), createArena(runtime)));
  bindKeyboard(runtime);
  startGameLoop(runtime);
}

function bindKeyboard(runtime: OrbitForgeRuntime): void {
  window.addEventListener("keydown", (event) => {
    if (event.code === "Space" && !event.repeat) {
      event.preventDefault();
      runtime.dispatch({ type: "set-shell-boost", active: true });
    }
    if (event.code === "Escape") {
      runtime.dispatch({ type: "close-panel" });
    }
  });

  window.addEventListener("keyup", (event) => {
    if (event.code === "Space") {
      event.preventDefault();
      runtime.dispatch({ type: "set-shell-boost", active: false });
    }
  });
}
